import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "pb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")!
  const _component_InteractiveCard = _resolveComponent("InteractiveCard")!
  const _component_Content = _resolveComponent("Content")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_ClassroomContent = _resolveComponent("ClassroomContent")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Hero, {
        course: _ctx.heroH5p ?? _ctx.course,
        role: _ctx.user.role
      }, null, 8, ["course", "role"]),
      (_ctx.course?.embedType! && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_InteractiveCard, {
            key: 0,
            data: {..._ctx.course!,..._ctx.heroH5p}
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (!_ctx.course?.embedType! && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_TabView, {
            key: 1,
            class: "custom-tabs-course"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TabPanel, {
                header: 
            _ctx.$t('labels.generic', {
              pt: _ctx.course.adaptive ? 'Grafo dos cursos' : 'Conteúdo do curso',
              en: _ctx.course.adaptive ? 'Courses graph' : 'Course content',
            })
          
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Content, {
                    data: _ctx.course,
                    role: _ctx.user?.role
                  }, null, 8, ["data", "role"])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_TabPanel, {
                header: _ctx.$t('labels.generic', { pt: 'Turmas', en: 'Classes' })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ClassroomContent)
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}